module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0003.jpg?v=cfded759";